module.exports = __webpack_public_path__ + "static/u-s-homeownership-rate-1-5e2b1529edeec0768d3fd1aa650c99e0.png";